import { SelectedFilters } from '@/components/FilterData/types';
import { useTenants } from '@/services/tenants/useTenants';
import { getApiError } from '@/types/apiError';
import { useQuery } from '@tanstack/react-query';
import { queryFunction, queryKey } from './query';

export const useTextSearch = ({
  searchQuery,
  selectedFilters,
  page,
  perPage,
  enabled = true,
  tenantId,
}: {
  searchQuery: string;
  selectedFilters?: SelectedFilters;
  page?: number;
  perPage?: number;
  enabled?: boolean;
  tenantId?: string;
}) => {
  const { getTenantId } = useTenants();
  const tenantIdValue = tenantId || getTenantId();
  const { data, isLoading, isFetching, error } = useQuery({
    queryKey: queryKey({
      searchQuery,
      selectedFilters,
      tenantId: tenantIdValue,
      page,
      perPage,
    }),
    queryFn: queryFunction({
      searchQuery,
      selectedFilters,
      tenantId: tenantIdValue,
      page,
      perPage,
    }),
    select: data => data.data,
    retry: false,
    enabled: enabled && !!tenantIdValue,
  });

  return { data, isLoading, isFetching, error: getApiError(error) };
};
